import React, { useState, useEffect } from "react";
import { Paginator } from "../../layout/Paginator/Paginator";
import { connect } from "react-redux";
import { showSpinner, hideSpinner } from "../../../store/actions/loading";
import { Search } from "../../layout/Table/Search";
import { TableComponent } from "./table/Table";
import { getOrganizations as getOrganizationsApi } from "../../../api/clients/organizations";
import { ACL, PAGE_CONTEXTS } from '../../../config/constants';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { ListToolbar } from "../../layout/Workspace";

let oneTimeCall = false;
function OrganizationsTableComponent(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [organizations, setOrganizations] = useState(null);
  const [meta, setMeta] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState( 10 );

  useEffect( () => {
    getOrganizations( 1, sortField, sortDirection, searchText );

    return () => {
      store.dispatch(hideNotification());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  /**
   * Get client organizations
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getOrganizations = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.CLIENT.USERS.LIST.hasAccess() || oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;

    getOrganizationsApi({
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
        page_context: PAGE_CONTEXTS.CLIENT_ORGANIZATION.LIST,
      },
      hideNotification: hideNotification,
    }).then((response) => {
      if (!response || !response.data) {
        return;
      }

      setOrganizations(response.data);
      setMeta(response.meta);
      props.hideSpinner();
    }).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getOrganizations(meta.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <div className="organizations-list-layout">
      <ListToolbar
        className="organizations-list-toolbar"
        search={ACL.CLIENT.USERS.SEARCH.hasAccess() ? (
          <Search
            permissions
            search={(searchText) => {
              setSearchText(searchText);
              getOrganizations(1, null, null, searchText, true);
            }}
            id="client-organizatons"
          />
        ) : null}
        settings={(
          <AutoRefreshTable
            id="client-organizatons"
            getData={getOrganizations}
            sortDirection={sortDirection}
            sortField={sortField}
            searchText={searchText}
          />
        )}
      />
      <div className="organizations-list-table">
        <TableComponent
          applySort={(sortField) => applySort(sortField)}
          organizations={organizations}
          actionCallback={(useState) => {
            if (useState) {
              getOrganizations(meta.current_page, sortField, sortDirection, searchText);
            } else {
              getOrganizations();
            }
          }}
        />
      </div>
      <div className="organizations-list-pagination">
        <Paginator
          meta={meta}
          settings={(
            <RowsPerPage
              changeRowsPerPage={(rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
              }}
              id="client-organizatons"
            />
          )}
          changePage={(page) =>
            getOrganizations(page, sortField, sortDirection, searchText, true)
          }
        />
      </div>
    </div>
  );
}

OrganizationsTableComponent.defaultProps = {};

const OrganizationsTable = connect(null, {
  showSpinner,
  hideSpinner,
})(OrganizationsTableComponent);

export { OrganizationsTable, OrganizationsTableComponent };
